var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tiny-chart",class:{
        'no-sensor-data': _vm.noSensorData,
        'allow-empty-navigation': _vm.allowEmptyNavigation,
    }},[(!_vm.noSensorData)?_c('LineChart',{attrs:{"series":_vm.series,"settings":_vm.chartSettings}}):_vm._e(),(_vm.noSensorData)?_c('div',{staticClass:"no-data"},[_vm._v(_vm._s(_vm.$tc("noData")))]):_vm._e(),(_vm.busy)?_c('div',{staticClass:"no-data"},[_c('Spinner',{staticClass:"spinner"})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }